module.exports = __webpack_public_path__ + "img/wechat.7f4ed750.png";